import { CallService } from "@/apis/base-jetpay/transaction.js";
import { HttpMethod } from "@/apis/base-jetpay/httpClient.js";

export default {
  /**
   * Hàm lấy danh sách transaction
   * CreateBy: PVPhong (17/05/2021)
   * @param {*} param0
   */
  async getTransactions({ commit, state }, response) {
    let url = `${window._apis.LogTransaction}/transactions`;
    // gọi API lấy danh sách transaction
    try {
      response = await CallService(url, {
        method: HttpMethod.GET,
        params: {
          SkipCount: state.paginations.start,
          MaxResultCount: state.paginations.itemsPerPage,
          ...state.filters,
        },
      });
      commit("SET_TRANSACTIONS", response.data);
      commit("TOTAL_AMOUNT");
    } catch (error) {
      console.log(error);
    }
  },
  /**
   * Hàm tìm kiếm danh transaction theo điều kiện
   * CreateBy: PVPhong (20/04/2021)
   * @param {*} param0
   */
  async filterTransactions({ commit, state }, response) {
    commit("SELECT_FILTER");
    let url = `${HttpMethod.transaction}`;
    // gọi API lấy danh sách transaction
    try {
      response = await CallService(url, {
        method: HttpMethod.GET,
        params: {
          SkipCount: state.paginations.start,
          MaxResultCount: state.paginations.itemsPerPage,
          ...state.filters,
        },
      });
      commit("SET_TRANSACTIONS", response.data);
    } catch (error) {
      console.log(error);
    }
  },

  /**
   * Hàm Refresh lại trang
   * CreatedBy: PVPhong (19/04/2021)
   */
  async refreshPage({ commit, state }, response) {
    commit("RESET_INPUT_FILTER");
    let url = `${HttpMethod.transaction}`;
    // gọi API lấy danh sách transaction
    try {
      response = await CallService(url, {
        method: HttpMethod.GET,
        params: {
          SkipCount: state.paginations.start,
          MaxResultCount: state.paginations.itemsPerPage,
          ...state.filters,
        },
      });
      commit("SET_TRANSACTIONS", response.data);
    } catch (error) {
      console.log(error.response);
    }
  },

  /**
    Hàm hiện thị đóng select item type dịch vụ
    */
  async setSelectTypeService({ commit }) {
    commit("SET_SHOW_TYPE_SERVICE");
  },

  /**
   * Hàm hiện thị đóng select item type dịch vụ
   */
  async setCloseSelectTypeService({ commit }) {
    commit("SET_CLOSE_TYPE_SERVICE");
  },
  /**
    Hàm hiện thị select hình thức thanh toán
    */
  async setSelectTypePayment({ commit }) {
    commit("SET_SHOW_TYPE_PAYMENT");
  },

  /**
   * Hàm hiện thị đóng select hình thức thanh toán
   */
  async setCloseSelectTypePayment({ commit }) {
    commit("SET_CLOSE_TYPE_PAYMENT");
  },
  /**
    Hàm hiện thị select hình thức thanh toán
    */
  async setSelectStore({ commit }) {
    commit("SET_SHOW_STORE");
  },

  /**
   * Hàm hiện thị đóng select hình thức thanh toán
   */
  async setCloseSelectStore({ commit }) {
    commit("SET_CLOSE_STORE");
  },

  /**
   * Ẩn hiện popup mở rộng
   */
  async setPopupExtend({ commit }) {
    commit("SET_SHOW_EXTEND");
  },

  /**
   * Ẩn hiện popup refund
   */
  async showPopUpRefund({ commit }) {
    commit("SET_SHOW_POPUP_REFUND");
  },
  /**
   * Hàm hiện thị select item
   */
  async setSelectStatus({ commit }) {
    commit("SET_SHOW_STATUS");
  },

  /**
   * Hàm hiện thị đóng select item time
   */
  async setCloseSelectStatus({ commit }) {
    commit("SET_CLOSE_STATUS");
  },

  /**
   * Lấy tên Store
   * @param {*} param0
   * @param {*} payload
   */
  async setNameStore({ commit }, name) {
    commit("SET_NAME_STORE", name);
  },

  /**
   * Lấy tên Type
   * @param {*} param0
   * @param {*} payload
   */
  async setNameType({ commit }, name) {
    commit("SET_NAME_TYPE", name);
  },
};
